import React, { useEffect } from 'react';
import { Profile } from '../../../../interfaces/profile';
import { useFormContext } from 'react-hook-form';
import FormDatiPrincipaliUtente from '../../../../components/FormDatiPrincipaliUtenti';

const ModificaUtenteAnagrafica = ({ userInfo }: { userInfo: Profile }) => {
  const { watch, setValue } = useFormContext();

  // Logica per cambiare le select di Nazione, regione e provincia

  useEffect(() => {
    //popola la select della provincia
    if (watch('region') === userInfo.attributes.region.data?.id) return;
    //resetta la provincia quando cambio regione
    setValue('province', null);
  }, [watch('region')]);

  useEffect(() => {
    // se la nazione non è cambiata rispetto a quella caricata dal profilo,
    // non tocco regione/provincia (es. Brasile + Estero vanno lasciati così)
    if (watch('nation') === userInfo.attributes.nation?.data?.id) return;
    if (watch('nation') !== 1) {
      setValue('province', null, { shouldDirty: true });
      setValue('region', null, { shouldDirty: true });
    }
  }, [watch('nation')]);

  useEffect(() => {
    setValue('homeAddress.province', null);
  }, [watch('homeAddress.region')]);

  useEffect(() => {
    if (
      watch('homeAddress.nation') ===
      userInfo.attributes.homeAddress?.nation?.data?.id
    )
      return;
    if (watch('homeAddress.nation') !== 1) {
      setValue('homeAddress.province', null, { shouldDirty: true });
      setValue('homeAddress.region', null, { shouldDirty: true });
    }
  }, [watch('homeAddress.nation')]);

  return (
    <div className=''>
      <FormDatiPrincipaliUtente infoUser={userInfo} />
    </div>
  );
};

export default ModificaUtenteAnagrafica;
